import { useEffect } from 'react';
import { useAppStore } from '../../use-app-store';
import { useVideoManager, type VideoTrigger } from './use-video-manager';

/**
 * Hook that connects the app store video triggers with the video manager
 */
export const useVideoTriggerHandler = () => {
  const { sub, unsub } = useAppStore();
  const { playVideo } = useVideoManager();

  useEffect(() => {
    const handleVideoTrigger = (payload?: object) => {
      if (!payload) return;
      const trigger = payload as VideoTrigger;
      playVideo(trigger);
    };

    // Subscribe to video trigger events
    sub('video_trigger', handleVideoTrigger);

    // Cleanup subscription on unmount
    return () => {
      unsub('video_trigger', handleVideoTrigger);
    };
  }, [sub, unsub, playVideo]);

  // Also listen for system events that might trigger videos
  useEffect(() => {
    const handleSystemEvent = (payload?: object) => {
      if (!payload) return;

      const systemEvent = payload as any;
      console.log('System event received:', systemEvent);

      // Handle potion completion events from AI
      if (systemEvent.action === 'potion_complete') {
        const { bottleType, color } = systemEvent.data;
        if (bottleType && color) {
          playVideo({ type: 'potion', bottleType, color });
        }
      }
      
      // Handle brewing effects
      else if (systemEvent.action === 'brewing_effect') {
        const { effectType } = systemEvent.data;
        if (effectType) {
          playVideo({ type: 'effect', effectType });
        }
      }
    };

    // System events that might trigger videos
    sub('system', handleSystemEvent);

    return () => {
      unsub('system', handleSystemEvent);
    };
  }, [sub, unsub, playVideo]);
};
